import axios from 'axios'
import _ from 'lodash'
import { setProfileAuthentication } from './setProfile'
import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'
import fetchHotelDescriptiveInfo from './fetchHotelDescriptiveInfo'
import yn from 'yn'

export const FETCH_CENDYN_PROFILE_USER_START = 'FETCH_CENDYN_PROFILE_USER_START'
export const FETCH_CENDYN_PROFILE_USER_SUCCESS = 'FETCH_CENDYN_PROFILE_USER_SUCCESS'
export const FETCH_CENDYN_PROFILE_USER_FAILURE = 'FETCH_CENDYN_PROFILE_USER_FAILURE'

export const fetchCendynProfileUser = (authToken) => async dispatch => {
		dispatch({ type: FETCH_CENDYN_PROFILE_USER_START })

	return axios.get(`${process.env.REACT_APP_CRM_PROFILE_URL}/oauth/userinfo`, {
		headers: {
			'Authorization': `Bearer ${authToken}`,
			'Content-Type': 'application/json',
		}
	})
		.then((res) => {
			const userPrefix = _.get(res, 'data.prefix', null)
			const userLoyaltyId = _.get(res, 'data.member_id', null)
			const userLoyaltyTier = _.get(res, 'data.member_level', null)
			const userLoyaltyPoints = _.get(res, 'data.points_balance', null)
			const userNightsToUpgrade = _.get(res, 'data.stays_until_free_night', null)
			const userFirstName = _.get(res, 'data.given_name', null)
			const userLastName = _.get(res, 'data.family_name', null)
			const userEmail = _.get(res, 'data.email', null)
			const userCity = _.get(res, 'data.locality', null)
			const userAddress = _.get(res, 'data.street_address_1', null)
			const userStateProv = _.get(res, 'data.address.locality', null)
			const userPostalCode = _.get(res, 'data.postal_code', null)
			const userCountry = _.get(res, 'data.address.country', null)
			const userPhoneNumber = _.get(res, 'data.phone_number', null)


			const formattedUser = {
				loyaltyId: userLoyaltyId,
				loyaltyTier: userLoyaltyTier,
				loyaltyTierUpgrade: null,
				loyaltyRewardsPoints: userLoyaltyPoints,
				nightsToUpgrade: userNightsToUpgrade,
				prefix: userPrefix,
				firstName: userFirstName,
				lastName: userLastName,
				phone: userPhoneNumber,
				address1: userAddress,
				city: userCity,
				stateProv: userStateProv,
				country: userCountry,
				postal: userPostalCode,
				email: userEmail
			}

			// Dispatch adaDescription GA events
			const profileUserData = {
				prefix: null,
				city: userCity,
				country: userCountry,
				userPostalCode,
				loyaltyTier: userLoyaltyTier,
				status: 'success'
			}

			triggerCustomGaEvent('analytics-profileFetchUser', profileUserData)

			dispatch({
				type: FETCH_CENDYN_PROFILE_USER_SUCCESS,
				payload: formattedUser,
			})
			dispatch(setProfileAuthentication(true))
			if (
				userLoyaltyTier &&
				yn(process.env.REACT_APP_COMPONENT_ENABLE_PROFILE_SERVICES) &&
				process.env.REACT_APP_CRM_PROVIDER === 'cendyn'
			) {
				dispatch(fetchHotelDescriptiveInfo(userLoyaltyTier))
			}
		}).catch(error => {
			const profileUserData = {
				status: 'error'
			}

			triggerCustomGaEvent('analytics-profileFetchUser', profileUserData)

			dispatch({
				type: FETCH_CENDYN_PROFILE_USER_FAILURE,
				payload: error,
			})
			dispatch(setProfileAuthentication(false))
		})
}


// WEBPACK FOOTER //
// ./src/actions/fetchCendynProfileUser.js